
import * as customCloudflareRuntime$Dhrlv0sRfg from '/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/providers/cloudflare/index.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 1024,
    "lg": 1536,
    "xl": 1920,
    "xxl": 1536,
    "2xl": 1536,
    "tb": 768,
    "ml": 1280
  },
  "presets": {},
  "provider": "customCloudflare",
  "domains": [
    "www.weareplaystation.fr"
  ],
  "alias": {},
  "densities": [
    1,
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['customCloudflare']: { provider: customCloudflareRuntime$Dhrlv0sRfg, defaults: {} }
}
        